module.exports = __webpack_public_path__ + "img/icon_getup_download_code.5c672540.png";